module.exports = __webpack_public_path__ + "img/backpack-icon.93025fd0.jpg";